<form [formGroup]="personalInformationsForm">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <!-- form -->
      <ion-col size="12" background-white-md-up>
        <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form max-width-form-md-up>
          <ion-col size="12" *ngIf="showPhoto">
            <app-profile-photo-circle
              [showIcon]="true"
              [iconName]="'COMPONENTS.FORMS.CAMERA' | translate"
              [photoUrl]="userPhotoUrl?.value"
              (photoUploaded)="setPhotoValue($event)"
            ></app-profile-photo-circle>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.NAME' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="userName"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_FULL_NAME' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="userName.dirty && userName.errors?.required">
              {{ 'COMPONENTS.FORMS.ENTER_THE_NAME' | translate }}
            </ion-note>

            <ion-note
              color="danger"
              *ngIf="userName.dirty && !userName.errors?.required && userName.errors?.maxlength"
            >
              {{ 'COMPONENTS.FORMS.THE_NAME_MUST_CONTAIN_AT_MOST' | translate
              }}{{ userName.errors.maxlength.requiredLength }} {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.CPF' | translate }}</ion-label>
            <ion-input
              type="tel"
              formControlName="userDocument"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_CPF' | translate }}"
              mask="cpf"
              dropSpecialCharacters
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="userDocument.dirty && userDocument.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_THE_CPF' | translate }}
            </ion-note>

            <ion-note
              color="danger"
              *ngIf="userDocument.dirty && !userDocument.errors?.required && userDocument.errors?.invalidCPF"
            >
              {{ 'COMPONENTS.FORMS.INVALID_CPF' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.PHONE' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="userPhone"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_NUMBER_OF_PHONE' | translate }}"
              mask="tel"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note color="danger" *ngIf="userPhone.dirty && userPhone.errors?.required">
              {{ 'COMPONENTS.FORMS.INSERT_THE_PHONE' | translate }}
            </ion-note>

            <ion-note
              color="danger"
              *ngIf="userPhone.dirty && !userPhone.errors?.required && userPhone.errors?.invalidPhone"
            >
              {{ 'COMPONENTS.FORMS.INVALID_PHONE' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.EMAIL' | translate }}</ion-label>
            <ion-input
              type="email"
              formControlName="userEmail"
              placeholder="{{ 'COMPONENTS.FORMS.ENTER_THE_LOGIN_EMAIL' | translate }}"
            ></ion-input>

            <!-- email required -->
            <ion-note color="danger" *ngIf="userEmail.dirty && userEmail.errors?.required">
              {{ 'COMPONENTS.FORMS.ENTER_THE_EMAIL' | translate }}
            </ion-note>

            <!-- email invalid -->
            <ion-note
              class="ion-margin-top ion-text-center"
              color="danger"
              *ngIf="userEmail.dirty && userEmail.errors?.email && !userEmail.errors?.required"
            >
              {{ 'COMPONENTS.FORMS.INVALID_EMAIL' | translate }}
            </ion-note>

            <!-- email max length -->
            <ion-note
              class="ion-margin-top ion-text-center"
              color="danger"
              *ngIf="
                userEmail.dirty &&
                !userEmail.errors?.email &&
                !userEmail.errors?.required &&
                userEmail.errors?.maxlength
              "
            >
              {{ 'COMPONENTS.FORMS.THE_EMAIL_MUST_CONTAIN' | translate }}
              {{ userEmail.errors.maxlength.requiredLength }} {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
            <ion-label position="stacked">{{ 'COMPONENTS.FORMS.REGULATORY_AGENCY' | translate }}</ion-label>
            <ion-input
              type="text"
              formControlName="userResponsibleCreci"
              placeholder="{{ 'COMPONENTS.FORMS.CRECI_CREA_ETC' | translate }}"
            >
              <ion-icon
                class="suffix-icon"
                src="assets/svg/edit-icon.svg"
                item-right
                *ngIf="editMode"
              ></ion-icon>
            </ion-input>

            <ion-note
              color="danger"
              *ngIf="
                userResponsibleCreci.dirty &&
                !userResponsibleCreci.errors?.required &&
                userResponsibleCreci.errors?.maxlength
              "
            >
              {{ 'COMPONENTS.FORMS.THE_REGULATORY_BODY_MUST' | translate }}
              {{ userResponsibleCreci.errors.maxlength.requiredLength }}
              {{ 'COMPONENTS.FORMS.CHARACTERS' | translate }}
            </ion-note>
          </ion-col>

          <ion-col size="12" class="ion-no-padding ion-margin-top ion-hide-md-up">
            <ion-button
              *ngIf="showButton"
              expand="block"
              color="buttonPrimary"
              (click)="submit(personalInformationsForm)"
              >{{ 'COMPONENTS.FORMS.SAVE' | translate }}</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-row
        class="ion-align-items-center ion-padding-horizontal ion-justify-content-end ion-hide-md-down"
        width-100
      >
        <ion-col size="12" class="ion-no-padding ion-margin-top ion-text-end">
          <ion-button
            *ngIf="showButton"
            color="primary"
            (click)="submit(personalInformationsForm)"
            width-300
            >{{ 'COMPONENTS.FORMS.SAVE' | translate }}</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-row>
  </ion-grid>
</form>
